// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1UcnH","label":"Radio_label__Vqwi_","checkMark":"Radio_checkMark__2QzHm","disabled":"Radio_disabled__cjGgz"};